import {Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {translations} from 'presentation/translations-new';
import {LinksBioHealth, LinksSaoLucasSaude} from 'presentation/constants';
import {AlertInfo} from '../AlertInfo';
import {OperatorAlertEnum, OperatorAlertProps, OperatorNameEnum} from './types';

const {bills, coparticipation, incomeTax, saoLucasBills, saoLucasCoparticipation, button} =
	translations['pt-br'].privateFlow.myFinancial.operatorAlert;

function AlertOperator({
	marginBottom,
	variant,
	operatorName = OperatorNameEnum.BIOHEALTH,
}: OperatorAlertProps) {
	const getText = () => {
		switch (variant) {
			case OperatorAlertEnum.BILLS:
				return (
					<Fragment>
						<Typography>
							{bills.line1}
							<Typography fontWeight="600" component="span">
								{bills.line2}
							</Typography>
							{bills.line3}
							<Typography fontWeight="600" component="span">
								{bills.line4}
							</Typography>
						</Typography>
					</Fragment>
				);
			case OperatorAlertEnum.INCOME_TAX:
				return (
					<Fragment>
						<Typography>
							{incomeTax.line1}
							<Typography fontWeight="600" component="span">
								{incomeTax.line2}
							</Typography>
							{incomeTax.line3}
							<Typography fontWeight="600" component="span">
								{incomeTax.line4}
							</Typography>
						</Typography>
					</Fragment>
				);
			case OperatorAlertEnum.COPARTICIPATION:
				return (
					<Fragment>
						<Typography>
							{coparticipation.line1}
							<Typography fontWeight="600" component="span">
								{coparticipation.line2}
							</Typography>
							{coparticipation.line3}
						</Typography>
					</Fragment>
				);
			case OperatorAlertEnum.SAO_LUCAS_BILLS:
				return (
					<Fragment>
						<Typography>
							{saoLucasBills.line1}
							<Typography fontWeight="600" component="span">
								{saoLucasBills.line2}
							</Typography>
							{saoLucasBills.line3}
							<Typography fontWeight="600" component="span">
								{saoLucasBills.line4}
							</Typography>
						</Typography>
					</Fragment>
				);
			case OperatorAlertEnum.SAO_LUCAS_COPARTICIPATION:
				return (
					<Fragment>
						<Typography>
							{saoLucasCoparticipation.line1}
							<Typography fontWeight="600" component="span">
								{saoLucasCoparticipation.line2}
							</Typography>
							{saoLucasCoparticipation.line3}
							<Typography fontWeight="600" component="span">
								{saoLucasCoparticipation.line4}
							</Typography>
						</Typography>
					</Fragment>
				);
			default:
				return null;
		}
	};

	const links = {
		biohealth: LinksBioHealth.PORTAL,
		saoLucasSaude: LinksSaoLucasSaude.PORTAL,
	};

	return (
		<AlertInfo.Root sx={{mb: marginBottom}}>
			<AlertInfo.Description>
				<Typography variant="body2">{getText()}</Typography>
			</AlertInfo.Description>
			<Stack>
				<AlertInfo.Action
					display="flex"
					justifyContent="flex-end"
					mt={1}
					$iconName="external-link-default"
					onClick={() => window.open(links[operatorName], '_blank')}>
					{button}
				</AlertInfo.Action>
			</Stack>
		</AlertInfo.Root>
	);
}

export {AlertOperator};
